import { useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router';
import queryString, { StringifiableRecord } from 'query-string';
import { SelectValue } from 'antd/lib/select';

const options = { parseBooleans: true };

export const useQuery = () => {
  const location = useLocation();
  const history = useHistory();

  const query = useMemo(() => queryString.parse(location.search, options), [location.search]);

  const pushQuery = useCallback(
    (queryObj: QueryType) => {
      const modifiedQuery = {
        ...query,
        ...queryObj,
      } as StringifiableRecord;

      Object.keys(modifiedQuery).forEach(
        key => modifiedQuery[key] === '' && delete modifiedQuery[key],
      );

      history.push({
        pathname: location.pathname,
        search: queryString.stringify(modifiedQuery),
      });
    },
    [history, location.pathname, query],
  );

  const replaceQuery = useCallback(
    (queryObj: QueryType) => {
      const modifiedQuery = {
        ...query,
        ...queryObj,
      } as StringifiableRecord;

      history.replace({
        pathname: location.pathname,
        search: queryString.stringify(modifiedQuery),
      });
    },
    [history, location.pathname, query],
  );

  return { query, pushQuery, replaceQuery };
};

type QueryType = {
  [name: string]: boolean | SelectValue | SelectValue[] | undefined;
};
